import authAxios from "../common/authAxios";

class PersonalSettingsService {

  async updateAccountInfo(data) {
    return await authAxios.post('/account-info/update-account-info', data);
  }

}

export default PersonalSettingsService;